import React from "react";
import { Route, Link, Switch } from 'react-router-dom';
import { Card, Steps, Progress, Row, Col } from 'antd';
import numeral from 'numeral';
import createHashHistory from 'history/createHashHistory';

import Common from './common';
import Lstd from './lstd';
import Jfbl from './jfbl';
import Ssfp from './ssfp';

import styles from '../index.css';
import defaultPortrait from '../../../styles/images/stuDefault.png';
import NHFetch from "../../../utils/NHFetch";
import { createUuid } from '../../../utils/NHCore';
import PropTypes from 'prop-types';

import Print from "../../../utils/Print";
import PrintTemplate from "../print/printTemplate";

const Step = Steps.Step;

const hashHistory = createHashHistory();
const basicUrl = '/yxxc/'; //基础请求路径

/**
 * 环节办理页面
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-03-23 16:46:57
 * Version: 1.0
 * Modify log:
 */
export default class StepForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            hjblztData: {},
            hjywxData: [],
            schoolName: '',//学校名称
            year: '',//当前年度
            account: '',//默认账号
            xsxx: [],//学生信息
            loading: false,//按钮状态
            //----------------------//
        }
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if ('hjblztData' in nextProps) {
            const hjblztData = nextProps.hjblztData;
            if (this.props.hjblztData !== nextProps.hjblztData) {
                this.setState({ hjblztData: hjblztData });
            }
        }

        if ('hjywxData' in nextProps) {
            const hjywxData = nextProps.hjywxData;
            this.setState({ hjywxData: hjywxData });
        }
    }


    //获取环节办理状态信息
    getHjblztData = (params) => {

        NHFetch(basicUrl + 'getHjblztByFilter', 'GET', params)
            .then(res => {
                if (res) {
                    let data = res.data;
                    if (data) {
                        this.setState({ hjblztData: data });
                    } else {
                        this.setState({ hjblztData: {} });
                    }
                }
            });
    }

    //获取环节业务项信息
    getHjywxData = (params) => {

        NHFetch(basicUrl + 'getHjywxByFilter', 'GET', params)
            .then(res => {
                if (res) {
                    let data = res.data;
                    if (data) {
                        this.setState({ hjywxData: data });
                    } else {
                        this.setState({ hjywxData: [] });
                    }
                }
            });
    }

    //获取环节办理信息
    getHjblxx = (hjid, lchjid) => {
        let studentData = this.props.studentData;
        let hjblxxFilter = {};
        hjblxxFilter.xsid = studentData.xsid;
        hjblxxFilter.hjid = hjid;
        hjblxxFilter.lchjid = lchjid;
        this.getHjblztData(hjblxxFilter);

        if (studentData.xsid) {
            this.getHjywxData(hjblxxFilter);
        }
    }

    //解析url搜索参数
    parseUrlParams() {
        let location = this.props.location;
        if (location) {
            const { search } = location;
            if (search) {
                let deocodeUrl = decodeURIComponent(search);
                let url = deocodeUrl.substring(1, search.length); //去除?
                let paramsStr = url.split('&'); //分割参数字符串

                if (paramsStr.length > 0) {

                    let params = {};
                    //解析成键值对形式对象
                    for (let key in paramsStr) {
                        let paramStr = paramsStr[key];
                        let paramObj = paramStr.split('=');
                        let obj = new Object;
                        obj[paramObj[0]] = paramObj[1];
                        Object.assign(params, obj);
                    }

                    return params;
                }
            }
        }
        return null;
    }

    // 获取路径中的当前步骤
    getCurrentStep() {
        let params = this.parseUrlParams();
        if (params) {
            return Number(params.key ? params.key : 0);
        }
    }

    //步骤条点击回调
    handleStepClick = (url, search, hjid, lchjid, stepNum) => {
        this.getHjblxx(hjid, lchjid);
        hashHistory.push({
            pathname: url,
            search: search
        });
    }

    //下一步操作
    handleNextStep = () => {
        const { lchjVOs } = this.props.lcpz;
        let currentStep = this.getCurrentStep();
        let nextStepData;
        let redirectUrl;
        let filter;
        if (lchjVOs && lchjVOs.length > 0) {
            for (let i = 1; i < lchjVOs.length - currentStep; i++) {
                let nextStep = currentStep + i;
                //获取下一步有操作权限、可操作的环节数据，如果没有，则继续往下查找，直到有权限可操作
                nextStepData = lchjVOs.filter(
                    (item, index) => parseInt(index) == parseInt(nextStep) && item.czqx == '1' && item.zt == '1')[0];
                if (nextStepData) {
                    redirectUrl = '/yxxc/step';
                    switch (nextStepData.hjdm) {
                        case 'GD001':
                            //绿色通道
                            redirectUrl += '/lstd';
                            break;
                        case 'GD002':
                            //缴费办理
                            redirectUrl += '/jfbl';
                            break;
                        case 'GD003':
                            //宿舍分配
                            redirectUrl += '/ssfp';
                            break;
                        default:
                            break;
                    }
                    filter = encodeURIComponent(`key=${nextStep}&lcid=${this.props.lcid}&hjid=${nextStepData.hjid}&lchjid=${nextStepData.pkid}`);
                    break;
                }
            }

            if (nextStepData && redirectUrl && filter) {
                this.getHjblxx(nextStepData.hjid, nextStepData.pkid);
                hashHistory.push({
                    pathname: redirectUrl,
                    search: filter
                });
            }
        }
    }

    //上一步操作
    handleLastStep = () => {
        const { lchjVOs } = this.props.lcpz;
        let currentStep = this.getCurrentStep();
        let lastStepData;
        let redirectUrl;
        let filter;
        if (lchjVOs && lchjVOs.length > 0) {
            for (let i = 1; i <= currentStep; i++) {
                let lastStep = currentStep - i;
                //获取上一步有操作权限、可操作的环节数据，如果没有，则继续往上查找，直到有权限可操作
                lastStepData = lchjVOs.filter(
                    (item, index) => parseInt(index) == parseInt(lastStep) && item.czqx == '1' && item.zt == '1')[0];
                if (lastStepData) {
                    redirectUrl = '/yxxc/step';
                    switch (lastStepData.hjdm) {
                        case 'GD001':
                            //绿色通道
                            redirectUrl += '/lstd';
                            break;
                        case 'GD002':
                            //缴费办理
                            redirectUrl += '/jfbl';
                            break;
                        case 'GD003':
                            //宿舍分配
                            redirectUrl += '/ssfp';
                            break;
                        default:
                            break;
                    }
                    filter = encodeURIComponent(`key=${lastStep}&lcid=${this.props.lcid}&hjid=${lastStepData.hjid}&lchjid=${lastStepData.pkid}`);
                    break;
                }
            }
            if (lastStepData && redirectUrl && filter) {
                this.getHjblxx(lastStepData.hjid, lastStepData.pkid);
                hashHistory.push({
                    pathname: redirectUrl,
                    search: filter
                });
            }
        }
    }

    //环节办理完成回调
    handleFinish = (flag) => {

        //办理完成回调
        const onFinish = this.props.onFinish;
        if (onFinish) {
            onFinish(flag);
        }
    }

    //打印报到单回调
    handlePrint = () => {
        const { xsid } = this.props.studentData;
        const getAccount = this.getAccount(xsid);
        const getCurrentYearAndSchool = this.getCurrentYearAndSchool();
        const getPrintInfo = this.getPrintInfo(xsid);
        if (xsid) {
            this.setState({ loading: true });
            Promise.all([getAccount, getCurrentYearAndSchool, getPrintInfo]).then(res => {
                this.setState({ loading: false });
                this.refs.print.onPrint();
            }).catch(err => {
                this.setState({ loading: false });
            });
        } else {
            message.error("环节办理失败,请先查询学生信息！");
        }
    }

    getAccount = (xsid) => {
        if (xsid == '') {
            message.error("打印出错！");
        }
        return NHFetch("/yxxc/getAccount", "GET", { xsid: xsid })
            .then(resData => {
                if (resData.data != null) {
                    this.setState({ account: resData.data });
                }
            });
    }

    getCurrentYearAndSchool = () => {
        return NHFetch("/yxxc/getCurrentYearAndSchool", "GET", null)
            .then(resData => {
                if (resData.data != null) {
                    let year = '';
                    let school = '';
                    resData.data.forEach(element => {
                        if (element.NAME == 'year') {
                            year = element.VALUE;
                        }
                        if (element.NAME == 'school') {
                            school = element.VALUE;
                        }
                    });
                    this.setState({ year: year, schoolName: school });
                }
            })
    }

    getPrintInfo = (xsid) => {
        if (xsid == '') {
            message.error("打印出错！");
        }
        return NHFetch("/yxxc/getInfoForPrint", 'GET', { xsid: xsid })
            .then(res => {
                if (res && res.data) {
                    this.setState({ xsxx: res.data })
                    this.setState({ loading: false })
                }
            })
    }

    render() {

        const { hjblztData, hjywxData, xsxx, account, year, schoolName, loading } = this.state;
        const { studentData, lcpz, pieData, stepsData, ybllchjData, } = this.props;
        const { lcdyVO, lchjVOs = [] } = lcpz;
        const { bdrs, zrs } = pieData;

        let currentStep = this.getCurrentStep();

        //当前流程环节配置数据
        let lchjData = lchjVOs.filter(item => {
            let lchjid = hjblztData.pkid;
            return item.pkid == lchjid;
        })[0];

        //流程统计数据
        const cardTitle = (
            <div>
                <span>{lcdyVO ? lcdyVO.lcmc : '流程'}进度</span>&nbsp;&nbsp;
                <Progress type="circle" percent={Number(numeral(bdrs / zrs * 100).format('0'))} width={30} />&nbsp;&nbsp;
                <span style={{ fontWeight: 'normal', fontSize: 14 }}>报到人数 <b>{bdrs}</b> / 总人数 {zrs}</span>
            </div>
        )

        //动态构造步骤条
        const stepItems = stepsData.map((item, index) => {
            let url = '/yxxc/step';
            switch (item.hjdm) {
                case 'GD001':
                    //绿色通道
                    url += '/lstd';
                    break;
                case 'GD002':
                    //缴费办理
                    url += '/jfbl';
                    break;
                case 'GD003':
                    //宿舍分配
                    url += '/ssfp';
                    break;
                default:
                    break;
            }

            let available = lchjVOs.filter(lchj => lchj.czqx == '1' && lchj.zt == '1' && item.lchjid == lchj.pkid)[0];
            //如果没有操作权限，则不可点击
            if (available) {
                let search = encodeURIComponent(`key=${index}&lcid=${available.lcid}&hjid=${available.hjid}&lchjid=${available.pkid}`);
                return (
                    <Step
                        key={index}
                        status={ybllchjData.indexOf(item.lchjid) != -1 ? 'finish' : 'wait'}
                        title={<a href="javascript:void(0)"
                            onClick={() => this.handleStepClick(url, search, available.hjid, available.pkid, index)}>{item.hjmc}</a>}
                        description={<span><b>{item.blrs}</b>/{item.lcrs}</span>} />
                );
            } else {
                return (
                    <Step
                        key={index}
                        status={ybllchjData.indexOf(item.lchjid) != -1 ? 'finish' : 'wait'}
                        title={item.hjmc}
                        description={<span><b>{item.blrs}</b>/{item.lcrs}</span>}
                    />
                );
            }
        });

        const steps = (
            <Steps type="navigation" current={currentStep} >
                {stepItems}
            </Steps>
        );

        return (

            <div className={styles.process_content}>
                <Card
                    size="large"
                    title={cardTitle}
                    bodyStyle={{ padding: 0 }}
                    extra={<Link to="/yxxc">返回迎新现场</Link>}>
                    <div style={{ borderBottom: '1px solid #e8e8e8' }}>
                        {steps}
                    </div>
                    <Print ref="print"
                        lazyRender={true}
                        insertHead={true}
                        winStyle='toolbar=yes,menubar=yes'
                        iframeStyle={'width:210px;height:297px'}
                        isIframe={false}
                    >
                        <PrintTemplate initFormDate={xsxx} schoolName={schoolName} year={year} account={account} />
                    </Print>
                    <Card title="个人信息" bordered={false}>
                        <Row className={styles.personal}>
                            <Col xl={3} lg={6} md={12} sm={24} xs={24}>
                                <img
                                    src={`api/sm-student/openapi/getStudentPhoto?xsid=${studentData.xsid}&type=50&uuid=${createUuid()}`}
                                    onError={e => {
                                        e.target.src = defaultPortrait
                                    }}
                                    style={{ width: 125, height: 150 }} />
                            </Col>
                            <Col xl={7} lg={9} md={12} sm={24} xs={24}>
                                <div><span>姓 名：</span>{studentData.xm}</div>
                                <div><span>性 别：</span>{studentData.xb}</div>
                                <div><span>民 族：</span>{studentData.mz}</div>
                                <div><span>学 院：</span>{studentData.bmmc}</div>
                                <div><span>班 级：</span>{studentData.bjmc}</div>
                            </Col>
                            <Col xl={7} lg={9} md={12} sm={24} xs={24}>
                                <div><span>身份证号：</span>{studentData.sfzjh}</div>
                                <div><span>出生日期：</span>{studentData.csrq}</div>
                                <div><span>学生类型：</span>{studentData.xslb}</div>
                                <div><span>专业：</span>{studentData.zymc}</div>
                                <div><span>宿舍信息：</span>{studentData.ssxqmc}{studentData.ldmc}{studentData.lcmc}{studentData.fjmc}{studentData.cwh ? '-' + studentData.cwh : studentData.cwh}</div>
                            </Col>
                            <Col xl={7} lg={12} md={12} sm={24} xs={24}>
                                <div><span>生源地：</span>{studentData.syd}</div>
                                <div><span>联系电话：</span>{studentData.sjhm}</div>
                            </Col>
                        </Row>
                        <Switch>
                            <Route exact path="/yxxc/step" render={
                                ({ location }) =>
                                    <Common location={location} studentData={studentData}
                                        hjblztData={hjblztData} hjywxData={hjywxData}
                                        lchjData={lchjData} onPrint={this.handlePrint}
                                        loading={loading}
                                        hasLast={currentStep != 0} hasNext={currentStep < stepsData.length - 1}
                                        onLast={this.handleLastStep} onNext={this.handleNextStep}
                                        onFinish={this.handleFinish} />
                            } />
                            <Route path="/yxxc/step/lstd" render={
                                ({ location }) =>
                                    <Lstd location={location} studentData={studentData} hjblztData={hjblztData}
                                        lchjData={lchjData} onPrint={this.handlePrint}
                                        loading={loading}
                                        hasLast={currentStep != 0} hasNext={currentStep < stepsData.length - 1}
                                        onLast={this.handleLastStep} onNext={this.handleNextStep}
                                        onFinish={this.handleFinish} />} />
                            <Route path="/yxxc/step/jfbl" render={
                                ({ location }) =>
                                    <Jfbl location={location} studentData={studentData}
                                        hjblztData={hjblztData} lchjData={lchjData}
                                        onPrint={this.handlePrint} hasLast={currentStep != 0}
                                        loading={loading}
                                        hasNext={currentStep < stepsData.length - 1}
                                        onLast={this.handleLastStep}
                                        onNext={this.handleNextStep}
                                        onFinish={this.handleFinish} />} />}

                            <Route exact path="/yxxc/step/ssfp" render={
                                ({ location }) =>
                                    <Ssfp location={location} studentData={studentData}
                                        hjblztData={hjblztData} hjywxData={hjywxData}
                                        lchjData={lchjData} onPrint={this.handlePrint}
                                        loading={loading}
                                        hasLast={currentStep !== 0} hasNext={currentStep < stepsData.length - 1}
                                        onLast={this.handleLastStep} onNext={this.handleNextStep}
                                        onFinish={this.handleFinish} />
                            } />
                        </Switch>
                    </Card>
                </Card>
            </div>
        )
    }
}

StepForm.propTypes = {
    location: PropTypes.object, //location信息
    lcid: PropTypes.string, //流程ID
    studentData: PropTypes.object, //学生信息
    lcpz: PropTypes.object, //流程配置信息
    pieData: PropTypes.object, //迎新流程统计饼图数据
    stepsData: PropTypes.array, //流程步骤配置信息
    hjblztData: PropTypes.object, //学生环节办理状态信息
    hjywxData: PropTypes.array, //环节业务项信息
    ybllchjData: PropTypes.array,//学生已办理的流程环节
    onFinish: PropTypes.func, //环节办理完成回调
}


// WEBPACK FOOTER //
// ./components/yxxc/steps/index.js